import { BrandButton } from "../ui/BrandButton";
import { brandInputClass, brandInlineActionClass } from "./fieldStyles";
import { FieldShell } from "./FieldShell";

export function BrandField({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  helper,
  type = "text",
  autoComplete,
  required = false,
  actionLabel,
  onActionClick,
  placeholder,
  className = "",
  showLabel = true,
}) {
  return (
    <FieldShell label={label} helper={helper} error={error} className={className} showLabel={showLabel}>
      <div className="relative">
        <input
          className={`${brandInputClass} ${actionLabel ? "pr-24" : ""}`}
          name={name}
          value={value}
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
          required={required}
          placeholder={placeholder}
          aria-invalid={Boolean(error)}
        />
        {actionLabel ? (
          <BrandButton
            type="button"
            onClick={onActionClick}
            variant="inline"
            radius="full"
            size="sm"
            motion="subtle"
            className={brandInlineActionClass}
          >
            {actionLabel}
          </BrandButton>
        ) : null}
      </div>
    </FieldShell>
  );
}
